import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { DrtIntegration } from '../model/types';

export const getDrtIntegrationsByStudio = async (
  studioId: string,
): Promise<Array<DrtIntegration>> => {
  const response = await baseAPI.get<Array<DrtIntegration>>(
    `/api/admin/drt/integrations/studio/${studioId}`,
  );
  return response.data;
};

export const useGetDrtIntegrationsByStudio = (studioId: string) => {
  return useQuery({
    queryKey: [KEYS.DRT_INTEGRATIONS, studioId],
    queryFn: () => getDrtIntegrationsByStudio(studioId),
    enabled: !!studioId,
  });
};
